export const planColors: Record<string, string> = {
  FREE: "bg-slate-100 dark:bg-slate-800 text-slate-600 dark:text-slate-400 border-slate-200 dark:border-slate-700",
  SILVER:
    "bg-slate-100 dark:bg-slate-700 text-slate-700 dark:text-slate-300 border-slate-300 dark:border-slate-600",
  GOLD: "bg-amber-50 dark:bg-amber-950/50 text-amber-700 dark:text-amber-400 border-amber-200 dark:border-amber-800",
  PLATINUM:
    "bg-indigo-50 dark:bg-indigo-950/50 text-indigo-700 dark:text-indigo-400 border-indigo-200 dark:border-indigo-800",
};

export const workspaceStatusBadge: Record<string, string> = {
  ACTIVE: "ACTIVE",
  SUSPENDED: "BLOCKED",
  CLOSED: "DISABLED",
};

export const statusToWorkspaceStatus: Record<string, string> = {
  All: "",
  Active: "ACTIVE",
  Suspended: "SUSPENDED",
  Closed: "CLOSED",
};

export const syncStatusBadge: Record<string, string> = {
  HEALTHY: "ACTIVE",
  WARNING: "WARNING",
  FAILED: "FAILED",
  PAUSED: "PAUSED",
};
